import React from 'react'
import Head from 'next/head'

export type StoreLocatorProps = {
    titleOverride?: string
    keywordOverride?: string
    descriptionOverride?: string
}

export const StoreLocator = ({
    titleOverride,
    keywordOverride,
    descriptionOverride
}: StoreLocatorProps): JSX.Element => {
    return (
        <Head>
            <title>{titleOverride}</title>
            <meta name="title" content={titleOverride} />
            <meta name="keywords" content={String(keywordOverride)} />
            <meta name="description" content={String(descriptionOverride)} />
        </Head>
    )
}
